/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { createContext, useContext } from 'react';

export const FooterInsetContext = createContext(0);

/**
 * Height covered by the pinned footer of the enclosing `FlightsBottomSheetView`
 * (footer plus the device's bottom safe area). The footer floats over the
 * body, so a list rendered with `scrollable={false}` should add this as bottom
 * padding to its content. Returns 0 outside a sheet or when there is no footer.
 */
export const useFlightsBottomSheetFooterInset = (): number =>
  useContext(FooterInsetContext);
